var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGhost = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.00033 6.66146H6.00699M10.0003 6.66146H10.007M8.00033 1.32812C6.58584 1.32813 5.22928 1.89003 4.22909 2.89022C3.2289 3.89042 2.66699 5.24697 2.66699 6.66146V14.6615L4.66699 12.6615L6.33366 14.3281L8.00033 12.6615L9.66699 14.3281L11.3337 12.6615L13.3337 14.6615V6.66146C13.3337 5.24697 12.7718 3.89042 11.7716 2.89022C10.7714 1.89003 9.41481 1.32813 8.00033 1.32812Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGhost);
export default ForwardRef;